// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3i6Ix","title":"card_title__2T6u1","inActive":"card_inActive__2IKd5"};